import { defineStore } from 'pinia'
import { initialState } from './main/initialState';
import { storeGetters } from './main/getters';
import { storeActions } from './main/actions';

export const useMainStore = defineStore('main', {
  state: () => (initialState),
  getters: storeGetters,
  actions: storeActions,
})